import script from "./AppSimpleDatatable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSimpleDatatable.vue?vue&type=script&setup=true&lang=ts"

import "./AppSimpleDatatable.vue?vue&type=style&index=0&id=57708d35&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57708d35"]])

export default __exports__